import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Shield } from 'lucide-react';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="glass-card-md p-8" data-testid="privacy-content">
          <div className="flex items-center mb-6">
            <Shield className="w-10 h-10 text-blue-500 mr-3" />
            <h1 className="text-4xl sm:text-5xl tracking-tight font-semibold text-white">Gizlilik Politikası</h1>
          </div>
          <div className="prose prose-slate max-w-none">
            <p className="text-white/60 mb-4">Son Güncelleme: 2026</p>
            <p className="text-white/70 mb-4">Doktor Cebinde olarak gizliliğinize saygı duyuyoruz ve kişisel verilerinizi korumayı taahhüt ediyoruz.</p>
            
            <h2 className="text-2xl font-medium text-white/90 mt-6 mb-3">Topladığımız Bilgiler</h2>
            <ul className="list-disc pl-6 text-white/70 space-y-2">
              <li>Kişisel bilgiler (ad, soyad, e-posta)</li>
              <li>Sağlık ve yaşam tarzı bilgileri (onboarding sürecinde)</li>
              <li>Günlük check-in verileri</li>
              <li>AI asistanla yapılan sohbetler</li>
            </ul>

            <h2 className="text-2xl font-medium text-white/90 mt-6 mb-3">Bilgileri Nasıl Kullanıyoruz</h2>
            <ul className="list-disc pl-6 text-white/70 space-y-2">
              <li>Size kişisel hizmet sunmak için</li>
              <li>AI asistanınızın daha iyi yanıtlar vermesi için</li>
              <li>İlerleme takibi ve grafikleri oluşturmak için</li>
              <li>Hizmet kalitemizi artırmak için</li>
            </ul>

            <h2 className="text-2xl font-medium text-white/90 mt-6 mb-3">Veri Güvenliği</h2>
            <p className="text-white/70">Tüm verileriniz şifrelenir ve güvenli sunucularda saklanır. Bilgileriniz üçüncü şahislarla paylaşılmaz.</p>

            <h2 className="text-2xl font-medium text-white/90 mt-6 mb-3">Haklarınız</h2>
            <p className="text-white/70">Verilerinize erişme, düzeltme veya silme hakkına sahipsiniz. Hesabınızı istediğiniz zaman silebilirsiniz.</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPage;